// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/home/jenkins/agent/workspace/dev-auto-build-frontend-account/go/src/github.com/axinan-com/goserver/auth-password/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "exact": false,
    "path": "/",
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "exact": true,
        "path": "/password/create",
        "component": require('@/pages/create').default
      },
      {
        "exact": true,
        "path": "/password/reset",
        "component": require('@/pages/reset').default
      },
      {
        "exact": true,
        "path": "/password/result/:code",
        "component": require('@/pages/result').default
      },
      {
        "component": require('@/pages/404').default,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
